import React, { useMemo } from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import CommonLoader from "../../../common/CommonLoader/CommonLoader";
import { useStudentCategories } from "../../../../hooks/api/education/useAcademicStructure";
import { formatEntityStatus } from "../common/academicUtils";

const StudentCategoryDetail: React.FC = () => {
  const { t } = useKivunovaTranslation();
  const { categoryId = "" } = useParams();
  const { data: categories = [], isPending } = useStudentCategories();

  const category = useMemo(
    () => categories.find((item) => item.id === categoryId),
    [categories, categoryId]
  );

  if (isPending) {
    return (
      <CommonLoader
        loadingMessage={t("loading-category", "Loading category...")}
      />
    );
  }

  if (!category) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>
          {t("category-not-found", "Category not found.")}
        </Typography>
      </Box>
    );
  }

  return (
    <Box data-testid="student-category-detail-page" sx={{ p: 3 }}>
      <Link component={RouterLink} to="..">
        {t("back-to-categories", "Back to student categories")}
      </Link>

      <Typography variant="h5" component="h1" sx={{ mt: 2, mb: 0.5 }}>
        {category.name}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>
        {formatEntityStatus(category.status)}
      </Typography>

      {category.description ? (
        <Typography variant="body2">{category.description}</Typography>
      ) : (
        <Typography variant="body2" color="text.secondary">
          {t("no-description", "No description.")}
        </Typography>
      )}
    </Box>
  );
};

export default StudentCategoryDetail;
